import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';

import { Icon } from 'components/Shared/Icon';
import { TYPOGRAPHY, CARDS, TRANSITION } from 'theme';

const CardIcon = styled(Icon)`
    color: ${ifProp('primary', TYPOGRAPHY.LINK_COLOR.BASE, TYPOGRAPHY.COLOR_REDUCED)};
    font-size: ${CARDS.ICON.SIZE};

    ${ifProp(
        'primary',
        css`
            transition: transform ${TRANSITION.LENGTH} ${TRANSITION.BEZIER};

            button:hover &,
            button:focus & {
                color: ${TYPOGRAPHY.LINK_COLOR.HOVER};
                transform: scale(1.25);
            }
        `
    )}
`;

export default CardIcon;
